import { useState } from 'react';

interface Props {
  text: string;
  label?: string;
}

/** Button that copies `text` to clipboard and flashes a "copied" state for 2s. */
export function CopyButton({ text, label = 'copy' }: Props) {
  const [copied, setCopied] = useState(false);

  async function handleClick() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  }

  return (
    <button type="button" className="copy-btn" data-copied={copied} onClick={handleClick}>
      {copied ? 'copied ✓' : label}
    </button>
  );
}
